module.exports = __webpack_public_path__ + "img/Airbnb-Equipment-Keyboard-Mouse-1.3598eef2.jpg";